var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taglist',{attrs:{"attached":""}},[_c('b-tag',{attrs:{"type":"is-grey"}},[_vm._v("Status")]),_c('b-tag',{attrs:{"type":_vm.statusType}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }